<template>
  <v-list-item
      @click="createPDF">
    <v-list-item-icon>
      <v-icon dense>mdi-printer</v-icon>
    </v-list-item-icon>
    <v-list-item-title>Cover Sheet</v-list-item-title>
  </v-list-item>
</template>

<script>
import PDFUtils from "@/utils/PDFUtils";
import gql from "graphql-tag";

export default {
  name: "FacilityProjectCoverSheet",

  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    facilityProject: {
      projectNo: "",
      name: "",
      facility: {
        building: "",
        name: "",
      },
    },
    relatedEntities: [],
  }),

  computed: {
    relatedEntitiesSortedByBuilding() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.relatedEntities
          .filter((entity) => entity.building !== this.primaryEntity.building)
          .sort((a, b) =>
              a.building > b.building ? 1 : b.building > a.building ? -1 : 0
          );
    },

    primaryEntity() {
      return (
          this.facilityProject.facility ||
          this.facilityProject.facilityComplex ||
          this.facilityProject.landEntity
      );
    },
  },

  apollo: {
    facilityProject: {
      query: gql`
        query ($projId: Decimal!) {
          facilityProject(where: { projectId: { eq: $projId } }) {
            projectId
            projectNo
            name
            year
            source
            facility {
              building
              name
            }
            landEntity {
              building
              name
            }
            facilityComplex {
              building
              name
            }
            relatedFacilityNos
            relatedProjects
          }
        }
      `,
      update: (data) => data.facilityProject[0],
      variables() {
        return {
          projId: parseInt(this.projectId),
        };
      },
    },
  },
  methods: {
    createPDF() {
      this.relatedEntities = []
      this.getRelatedEntities().then((results) => {
        results.forEach((response) => {
          response.data.projectEntity.forEach((entity) => this.relatedEntities.push(entity))
        }, this)

        this.trackPDF(this.facilityProject)
        console.log(this.relatedEntitiesSortedByBuilding)

        PDFUtils.createProjectCoverSheet(
            this.facilityProject,
            this.primaryEntity,
            this.relatedEntitiesSortedByBuilding
        )
      })
    },

    trackPDF(project) {
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'Project Cover Sheets',
        action: 'click',
        label: project.name,
        value: project.projectNo,
        noninteraction: false, // Optional
      })
    },

    getRelatedEntities() {
      let apolloQueries = []

      this.facilityProject.relatedFacilityNos
          .slice(1, -1)
          .split(",")
          .forEach((facilityNo) => {
            apolloQueries.push(
                this.$apollo
                    .query({
                      query: gql`
                query ($facNo: String!) {
                  projectEntity: facility(where: { building: { eq: $facNo } }) {
                    building
                    name
                  }
                }
              `,
                      variables: {
                        facNo: facilityNo,
                      },
                    }))

            apolloQueries.push(this.$apollo
                .query({
                  query: gql`
                query ($facNo: String!) {
                  projectEntity: landEntity(where: { building: { eq: $facNo } }) {
                    building
                    name
                  }
                }
              `,
                  variables: {
                    facNo: facilityNo,
                  },
                }))

            apolloQueries.push(this.$apollo
                .query({
                  query: gql`
                query ($facNo: String!) {
                  projectEntity: facilityComplex(where: { building: { eq: $facNo } }) {
                    building
                    name
                  }
                }
              `,
                  variables: {
                    facNo: facilityNo,
                  },
                }))
          })

      return Promise.all(apolloQueries)
    }
  }
  ,
}
;
</script>

<style scoped>
.v-list-item__icon {
  height: 24px;
  margin: 0px !important;
  margin-right: .5em !important;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 20px;
  height: 24px;
}

.v-list-item__title {
  font-weight: 400 !important;
}
</style>
